export function randHex(len) {
  var maxlen = 8;
  var min = Math.pow(16,Math.min(len,maxlen)-1);
  var max = Math.pow(16,Math.min(len,maxlen)) - 1;
  var n = Math.floor( Math.random() * (max-min+1) ) + min;
  var r = n.toString(16);
  while ( r.length < len ) {
    r = r + randHex( len - maxlen );
  }
  return r.toString().toUpperCase();
}


export function convertTo24DigitsHexadecimal(number) {
  var hex = number.toString(16)
  hex = hex.padStart(24, '0')
  return hex.toUpperCase()
}